import { render, staticRenderFns } from "./PetitionsReviewFilters.vue?vue&type=template&id=7669c4e4"
import script from "./PetitionsReviewFilters.vue?vue&type=script&lang=js"
export * from "./PetitionsReviewFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports